// @ts-ignore
import { /*loader,*/ gql } from "graphql.macro";

const virtualInstruments = gql`
  query virtualInstruments(
    $panelCollectionName: String!
    $panelName: String!
    $node: String!
    $tab: String!
  ) # $view: String!
  {
    virtualInstruments(
      panelCollectionName: $panelCollectionName
      panelName: $panelName
      node: $node
      tab: $tab
    )
      # view: $view
      @rest(
        type: "LiveDataPanelVirtualInstrument"
        path: "livedata/panels/{args.panelName}/vi?node={args.node}&tab={args.tab}&template={args.panelCollectionName}&view=vi"
      ) {
      uri
      name
    }
  }
`;

export default virtualInstruments;
